import { render, staticRenderFns } from "./NetworkCategoriesList.vue?vue&type=template&id=570b88a4&scoped=true&"
import script from "./NetworkCategoriesList.vue?vue&type=script&lang=js&"
export * from "./NetworkCategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./NetworkCategoriesList.vue?vue&type=style&index=0&id=570b88a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b88a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570b88a4')) {
      api.createRecord('570b88a4', component.options)
    } else {
      api.reload('570b88a4', component.options)
    }
    module.hot.accept("./NetworkCategoriesList.vue?vue&type=template&id=570b88a4&scoped=true&", function () {
      api.rerender('570b88a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/network-categories/NetworkCategoriesList.vue"
export default component.exports